export default __webpack_public_path__ + "static/media/PrizeCupGold.2ef763ee.png";